import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useFormikContext } from 'formik'
import { makeStyles } from 'tss-react/mui'
import { TextField } from '@e3dc-react/shell/Elements/InputFields'
import { WallboxTariffsFormData } from '../EMobilityWallboxTariffsEditor'

interface EMobilityWallboxChargeTariffsTextFieldProps {
  price: number
  index: number
}

const useStyles = makeStyles()(theme => ({
  input: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
  },
}))

/**
 * TexField input component for add charging price.
 * @param validFrom date input value
 * @param index number of input inside FieldArray
 * @return JSX element
 */
const EMobilityWallboxChargeTariffsTextField: React.FC<EMobilityWallboxChargeTariffsTextFieldProps> = ({ price, index }): JSX.Element => {
  const { setFieldValue, errors } = useFormikContext<WallboxTariffsFormData>()
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <TextField
      value={price.toString()}
      type="number"
      step={0.1}
      label={t('emobility.wallbox.editTariffs.pricePerKwh')}
      placeholder={t('emobility.wallbox.editTariffs.pricePerKwh')}
      clearable={false}
      onChange={value => setFieldValue(`chargePrices.${index}.price`, value)}
      className={classes.input}
      helperText={(() => {
        if (!errors.chargePrices) {
          return undefined
        }
        if (!errors.chargePrices[index]) {
          return undefined
        }

        const err = errors.chargePrices[index]

        if (typeof err === 'string') {
          return undefined
        }

        return err.price
      })()}
    />
  )
}

export default EMobilityWallboxChargeTariffsTextField
